import {memo, useEffect} from 'react'

import {useBanners} from '../../../contexts/Banners/BannersContext'
import {usePipelineId} from '../../../hooks/pipeline'

import Banner from './Banner/Banner'

const MAX = 6

function Banners() {
  const pipelineId = usePipelineId()
  const {items, removeAllBanners} = useBanners()

  useEffect(() => () => removeAllBanners?.(), [removeAllBanners])

  return (
    <>
      {items?.[pipelineId]
        ?.slice(-MAX)
        .map(({key, actions, title, message, closeable, type}) => (
          <Banner
            key={key}
            id={key}
            type={type}
            title={title}
            message={message}
            closeable={closeable}
            actions={actions}
          />
        ))}
    </>
  )
}
export default memo(Banners)
